// 618活动
// export default {
//     "isShow": false,
//     "PCactiveImg":"https://s21.lgstatic.com/growth/activity/20210615/1623747270256.png",
//     "BPCactiveImg":"https://s21.lgstatic.com/growth/activity/20210615/1623747270256.png",
//     "H5activeImg":"https://s21.lgstatic.com/growth/activity/20210615/1623747254518.png",
//     "BH5activeImg":"https://s21.lgstatic.com/growth/activity/20210615/1623747254518.png",
//     "PCicon":"https://s21.lgstatic.com/growth/activity/20210615/1623738960533.png",
//     "H5icon":"https://s21.lgstatic.com/growth/activity/20210615/1623738933531.png",
// }

// 818 活动
export default {
    "isShow": false,
    "PCactiveImg":"https://s20.lgstatic.com/growth/activity/20210819/1629360886597.png",
    "BPCactiveImg":"https://s20.lgstatic.com/growth/activity/20210819/1629360886597.png",
    "H5activeImg":"https://s20.lgstatic.com/growth/activity/20210819/1629360758855.png",
    "BH5activeImg":"https://s20.lgstatic.com/growth/activity/20210819/1629360758855.png",
    "PCicon":"https://s21.lgstatic.com/growth/activity/20210819/1629361078209.png",
    "H5icon":"https://s20.lgstatic.com/growth/activity/20210819/1629361057057.png",
}